import { Breakpoints } from "@domun/component-library";
import styled from "styled-components";

export const MobileViewStyles = styled.div`
  display: none;

  /*
   * En movil esto era un overlay a pantalla completa (100vh/100vw) que dejaba
   * la descarga de la app como unica salida: no se podia completar el registro
   * desde el navegador. Ahora es una banda compacta arriba del formulario, asi
   * que descargar la app es una opcion y no un muro.
   */
  @media screen and (max-width: ${Breakpoints.Tablet}) {
    display: block;
    width: 100%;
    .mobile-container {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      justify-content: space-between;
      padding: 12px 16px;
      background: #fafafa;
      border-bottom: 1px solid #e9e9e9;
      .logo-mobile {
        display: flex;
        width: 96px;
        height: 32px;
        .img {
          width: 100%;
          object-fit: contain;
        }
      }
      .body-mobile {
        align-items: center;
        display: flex;
        flex: 1 1 auto;
        gap: 0.75rem;
        justify-content: flex-end;
        .header-texts {
          color: var(--Grey-B, #24272e);
          display: flex;
          flex-direction: column;
          text-align: right;
          h1 {
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            margin: 0;
          }
          /* El subtexto largo no cabe en una banda: se omite en movil. */
          p {
            display: none;
          }
        }
        /* Los iconos de tienda sobran en el formato compacto. */
        .icons {
          display: none;
        }
      }
      .button-mobile-view {
        align-items: center;
        border-radius: 8px;
        background: var(--Grey-B, #24272e);
        display: flex;
        gap: 4px;
        height: 36px;
        justify-content: center;
        padding: 0px 12px;
        white-space: nowrap;
        .button-text {
          color: var(--Grey-800, #fcfcfc);
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          text-align: center;
        }
      }
    }
    /* La ilustracion solo tenia sentido a pantalla completa. */
    .mobile-image-container {
      display: none;
    }
  }
`;
